import { ReactElement, ReactNode } from 'react';
import { NextPage } from 'next';
import { AppProps } from 'next/app';

import { withErrorHandling } from '@lib/errors';

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
  isPublic?: boolean;
};

export const getRenderPage = (
  Component: NextPageWithLayout,
  pageProps: AppProps['pageProps']
) => {
  const getLayout = Component?.getLayout || ((page: ReactElement) => page);
  const View = withErrorHandling((props) => <Component {...props} />);
  const Page = getLayout(<View {...pageProps} />);
  return Page;
};
